import { Button } from "antd";
import React, { useState, useMemo, useEffect } from "react";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import {
  saveDescription,
  getFileDescription,
  getChangesFlag,
  setunSavedRulesChanges,
} from "../store/workspaceSlice";
const Notes = () => {
  const [notes, setNotes] = useState("");
  const existingDescription = useSelector(getFileDescription);
  const dispatch = useDispatch();
  const unsavedflag = useSelector(getChangesFlag);
  useEffect(() => {
    setNotes(existingDescription || "");
  }, [existingDescription]);

  const modules = useMemo(
    () => ({
      toolbar: [
        [{ header: [1, 2, 3, false] }],
        ["bold", "italic", "underline", "strike"],
        [{ list: "ordered" }, { list: "bullet" }],
        [{ color: [] }, { background: [] }],
        ["clean"],
      ],
    }),
    [],
  );

  const formats = [
    "header",
    "bold",
    "italic",
    "underline",
    "strike",
    "list",
    "bullet",
    "color",
    "background",
  ];

  const saveNotes = () => {
    dispatch(setunSavedRulesChanges(false));
    dispatch(saveDescription(notes));
    toast.success("Notes saved successfully!");
  };

  return (
    <div className="w-full p-8 bg-gray-50 flex flex-col">
      <h2 className="text-2xl font-semibold mb-4">Notes</h2>

      {/* EDITOR CONTAINER */}
      <div className="w-full border border-gray-300 rounded-lg bg-white">
        <div className="custom-quill-editor flex flex-col">
          <ReactQuill
            theme="snow"
            value={notes}
            onChange={(notes) => {
              setNotes(notes);
              if (!unsavedflag) {
                dispatch(setunSavedRulesChanges(true));
              }
            }}
            modules={modules}
            formats={formats}
            placeholder="Add detailed description, instructions, or notes about this mapping configuration. You can use formatting to organize your content..."
          />
        </div>

        <Button
          type="primary"
          className="m-4 self-end transition-all duration-150 active:scale-95 active:shadow-inner hover:shadow-md"
          onClick={saveNotes}
        >
          Save Notes
        </Button>
      </div>

      {/* HEIGHT + SCROLL CONTROL */}
      <style>
        {`
          .custom-quill-editor {
            min-height: 280px;   /* ✅ DEFAULT HEIGHT */
            max-height: 500px;   /* ✅ MAX HEIGHT */
          }

          .custom-quill-editor .ql-toolbar {
            border-bottom: 1px solid #e5e7eb;
            background-color: #f9fafb;
            position: sticky;
            top: 0;
            z-index: 10;
          }

          .custom-quill-editor .ql-container {
            min-height: 240px;   /* min-height - toolbar */
            max-height: 460px;   /* max-height - toolbar */
            overflow: hidden;
          }

          .custom-quill-editor .ql-editor {
            min-height: 240px;
            max-height: 460px;
            overflow-y: auto;
            font-size: 15px;
          }
        `}
      </style>
    </div>
  );
};

export default Notes;
